export const enum TestIds {
  Files = 'files',
  LowerAppetite = 'lowerAppetite',
  LowerTolerance = 'lowerTolerance',
  Owners = 'indicatorFrom-owners',
  TargetValueTxt = 'targetValueTxt',
  Type = 'type',
  UpperAppetite = 'upperAppetite',
  UpperTolerance = 'upperTolerance',
}
